import { Injectable } from '@angular/core';

import { HeaderItemModel } from '../model/header-item.model';
import { BaseService } from './base.service';

@Injectable()
export class ReportService {

	path = '/report';

	constructor(private baseService: BaseService) { }

	checklistAnswered(init: number, end: number, checklist_id: number, init_date: string, end_date: string, unconformities_only: boolean, withUnconformities: string, withAttachments: string, origin_id: number, headerItems: HeaderItemModel[], users:any[], full_only: boolean, primary_header_response: string) {
		console.log(full_only)
		return this.baseService.postWithParams(this.path, '/checklist-answered', headerItems, {
			init,
			end,
			checklist_id,
			init_date,
			end_date,
			unconformities_only,
			withUnconformities,
			withAttachments,
			origin_id,
			users,
			full_only,
			primary_header_response
		});
	}

	getUnconformities(init: number, end: number, checklistIds: number[], init_date: string, end_date: string, origin_id: number,checklist_response_ids:number[], userObservation?: boolean) {
		return this.baseService.get(this.path, '/unconformities-by-checklist', {
			init_date, end_date, init, end, checklistIds, origin_id, checklist_response_ids, userObservation,
		})
	}

	getQuantities(init: number, end: number, checklistIds: number[], init_date: string, end_date: string, origin_id: number, checklist_response_ids:number[]) {
		return this.baseService.get(this.path, '/quantities-by-checklist', {
			init_date, end_date, init, end, checklistIds, origin_id,checklist_response_ids
		})
	}

	getChecklistAnswered(id: number, params) {
		return this.baseService.get(this.path, `/checklist-answered/${id}`, params);
	}

	getChecklistsAnsweredComplete(params?) {
		return this.baseService.post('/checklist-response', '/checklist-answered-complete', params);
	}

	getChecklists(params?) {
		return this.baseService.get('/checklist', '/getAllWithParams', params);
	}

  resendEmail(id: number) {
    return this.baseService.get(this.path, '/checklist-response/resend-email/' + id, { id });
  }

  updateAnalisy(body: any) {
    return this.baseService.post(this.path, '/checklist-response/update-analisy/', body);
  }

  postObservation(body: any) {
    return this.baseService.post(this.path, '/checklist-response/post-observation/', body);
  }

	getResponses(params) {
		return this.baseService.get('/checklist-response/', `get-simple`, params);
	}

  deleteResponse(id: number) {
    return this.baseService.delete('/checklist-response', '/' + id);
  }

  getFilteredMeasureTables(params?) {
    return this.baseService.get('/measure-table', '/', params);
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/report.service.ts